import {BaseResultDTO} from "./baseResultDTO.interface";
import {CustomerDTO} from "../index";
import {SearchResultDTO} from "./searchResultDTO.interface";

export interface CustomerSearchResultDTO extends BaseResultDTO, SearchResultDTO
{
  customer?: CustomerDTO;
  customers?: CustomerDTO[];
}
